/* collapses
 ========================================================================== */
function showContent(btn, content) {
    const currentHeight = `${content.clientHeight}px`;
    content.classList.add('is-opened');
    const openedHeight = `${content.clientHeight}px`;
    content.style.height = currentHeight;
    setTimeout(() => {
        content.style.height = openedHeight;
    }, 0);
    content.addEventListener('transitionend', () => {
        content.style.height = 'auto';
    }, {
        once: true,
    });
    btn.setAttribute('aria-expanded', 'true');
}
function hideContent(btn, content) {
    const currentHeight = `${content.clientHeight}px`;
    content.classList.remove('is-opened');
    const closedHeight = `${content.clientHeight}px`;
    content.classList.add('is-opened');
    content.style.height = currentHeight;
    setTimeout(() => {
        content.style.height = closedHeight;
    }, 0);
    content.addEventListener('transitionend', () => {
        content.classList.remove('is-opened');
        content.style.height = 'auto';
    }, {
        once: true,
    });
    btn.setAttribute('aria-expanded', 'false');
}
export default function addCollapses() {
    const collapses = document.querySelectorAll('[data-component="collapse"]');
    collapses.forEach((collapse) => {
        const btn = collapse.querySelector('[data-collapse-target="btn"]');
        btn.addEventListener('click', () => {
            const container = btn
                .closest('[data-component="collapse"]')
                .querySelector('[data-collapse-target="text"]');
            if (btn.getAttribute('aria-expanded') === 'false') {
                showContent(btn, container);
            }
            else {
                hideContent(btn, container);
            }
        });
    });
}
